import api from "utils/helpers/api";

export const actionGetBookerInfo = (id: string | number) => {
  return api({ method: "get", url: "/public/user-info", params: { id } });
};

export const actionPackagesOfUsers = (data: any) => {
  return api(
    {
      method: "post",
      url: "/vip/activePackagesOfUsers",
      data,
    },
    "apis"
  );
};
